import { Route, Routes } from "react-router-dom";
import Home from './component/home';
import About from "./component/about";
import NotFound from "./component/notFound";

function Givo() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home></Home>}></Route>
        <Route path="/about" element={<About></About>}></Route>
        <Route path="*" element={<NotFound></NotFound>}></Route>
      </Routes>
    </>
  );
}

export default Givo;
